import { CssBaseline, ThemeProvider } from "@mui/material";
import { getTheme } from "@src/appV2/redesign/system/ui-theme";
import { Redirect } from "react-router-dom";

import { PageWrapper } from "../components/PageWrapper";
import { MY_SHIFTS_FULL_PATH } from "../WorkerShifts/path";
import { useIsInHomeEnabled } from "./lib/useIsInHomeEnabled";
import { InHomeRouter } from "./Router";

export function InHomeContainer() {
  const isInHomeEnabled = useIsInHomeEnabled();

  if (!isInHomeEnabled) {
    return <Redirect to={MY_SHIFTS_FULL_PATH} />;
  }

  return (
    <ThemeProvider theme={getTheme()}>
      <CssBaseline />
      <PageWrapper>
        <InHomeRouter />
      </PageWrapper>
    </ThemeProvider>
  );
}
